<script setup lang="ts">
import SendSmsPage from '../features/send-sms/SendSmsPage.vue';
</script>

<template>
  <SendSmsPage />
</template>
